import { Box } from '@scality/core-ui/dist/next';
import type React from 'react';
import { renderUIComponent } from '../../components/chat-messages/renderUIComponent';
import type { PanelItem } from '../types/panelItem';

type PanelItemCardProps = {
  item: PanelItem;
};

export const PanelItemCard: React.FC<PanelItemCardProps> = ({ item }) => (
  <Box width="100%" minWidth={0}>
    {renderUIComponent(item.componentName, item.params)}
  </Box>
);
